var e4    = e4 || {},
    juuls = juuls || {};
( function () {
    'use strict';
    jQuery( function () {
        juuls.init();
    } );
    jQuery( window ).on( 'load', function () {
        juuls.deferImages.init();
        juuls.search.init();
    } );
    juuls.init                = function () {
        juuls.klaviyo.init();
        juuls.navigation.init();
        juuls.tastingNoteCarousel.init();
        juuls.ecom.init();
        juuls.cc.init();
        if (jQuery('.js-e-product').length === 1) {
            juuls.pdf.init(); 
        }
        jQuery('[data-toggle="popover"]').popover();

    };
    juuls.generateGuid = function () {
        /* jshint ignore:start */
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace( /[xy]/g, function ( char ) {
            var result = Math.random() * 16 | 0, v = char === 'x' ? result : ( result & 0x3 | 0x8 );
            return v.toString( 16 );
        } );
        /* jshint ignore:end */
    };
    
    juuls.ui                  = {
        confirm: function ( objConfirmOptions, fnCallbackAccept, arrCallbackArgs ) {
            var arrAcceptedTypes = [
                    'alert',
                    'confirm'
                ],
                objDefaults      = {
                    header: location.origin + ' siger:',
                    text: '',
                    type: 'alert'
                },
                objOptions       = Object.assign( {}, objDefaults, objConfirmOptions );
            if ( arrAcceptedTypes.indexOf( objOptions.type ) === -1 ) {
                objOptions.type = 'alert';
            }
            return new Promise( function ( resolve, reject ) {
                var jModal = jQuery( '.js-confirm-modal' );
                jModal.find( '.js-confirm-modal-header' ).text( objOptions.header );
                if(objOptions.text !== ''){
                    jModal.find( '.js-confirm-modal-text' ).text( objOptions.text ).removeClass('d-none');
                } else{
                    jModal.find( '.js-confirm-modal-text' ).text( '' ).addClass('d-none');
                }
                
                jModal.find( `[data-confirm-type="${objOptions.type}"]` ).removeClass( 'd-none' );
                jModal.on( 'click', '.js-confirm-modal-accept-btn', function () {
                    resolve( fnCallbackAccept );
                } ).on( 'click', '.js-confirm-modal-cancel-btn', function () {
                    reject();
                } ).on( 'hidden.bs.modal', function () {
                    jModal.find( '[data-confirm-type' ).addClass( 'd-none' );
                } ).modal( 'show' );
            } ).then( function ( fnResolvedCallback ) {
                if ( typeof fnResolvedCallback === 'function' ) {
                    var arrResolvedArgs = Array.prototype.slice.call( arrCallbackArgs || [], 0 );
                    fnResolvedCallback.apply( this, arrResolvedArgs );
                }
            } );
        }
    };
    juuls.tastingNoteCarousel = {
        init: function () {
            var leftPos    = 0,
                idx        = 0;
            var listItems  = jQuery( '.juuls-smagsnoter-img-container .juuls-smagsnoter-row' ),
                totalItems = listItems.children().length;
            jQuery( '.total-items' ).html( totalItems );
            jQuery( '.carousel-control-next.control-arrow' ).click( function ( event ) {
                var parent = jQuery( event.target ).closest( '.juuls-product-main' );
                idx += 1;
                idx        = ( idx > totalItems - 3 ) ? totalItems - 3 : idx;
                leftPos    = idx * 110;
                //console.log( 'totalItems:', totalItems );
                //console.log( 'idx:', idx );
                listItems.animate( { marginLeft: -leftPos }, 300 );
            } );
            jQuery( '.carousel-control-prev.control-arrow' ).click( function ( event ) {
                var parent     = jQuery( event.target ).closest( '.juuls-product-main' ),
                    listItems  = jQuery( '.juuls-smagsnoter-img-container .juuls-smagsnoter-row' ),
                    totalItems = listItems.children.length;
                idx -= 1;
                idx            = ( idx < 0 ) ? 0 : idx;
                leftPos        = -idx * 110;
                //console.log( 'idx:', idx );
                listItems.animate( { marginLeft: leftPos }, 300 );
            } );
            //jQuery( window ).on( 'resize', function () {
            //jQuery( '.juuls-product-main .js-juuls-section-left-amount' ).css( 'marginLeft', $(window).width()*0.08 );
            //} );
        }
    };
    juuls.navigation          = {
        init: function () {
            juuls.navigation.bindEvents();
            juuls.navigation.spotProduct.init();
        },
        bindEvents: function () {
            jQuery( '.e-nav-hamburger-header' ).on( 'click', '.js-toggle-hamburger-icon', function ( event ) {
                jQuery( event.target ).closest( '.hamburger' ).toggleClass( 'is-active' );
            } );
        },
        spotProduct: {
            init: function () {
                var jNavigationSpotProducts = jQuery( '.js-juuls-navigation-spot-product' );
                if ( jNavigationSpotProducts.length > 0 ) {
                    e4.require.js( e4.settings.require.jQueryValidate, function () {
                        jNavigationSpotProducts.each( function ( index, domElm ) {
                            juuls.navigation.spotProduct.getSpotProduct( domElm ).done( function ( spotProductHtml ) {
                                jQuery( domElm ).find( '.js-juuls-navigation-spot-product-header' ).after( spotProductHtml );
                                var domForm = jQuery( domElm ).find( '.js-e-product-form' ).get( 0 );
                                e4.product.validateForm( domForm ); 
                            } );
                        } );
                    } );
                }
            },
            getSpotProduct: function ( domElm ) {
                return jQuery.ajax( {
                    url: e4.settings.ecom.spotproduct.url,
                    data: domElm.dataset
                } );
            }
        }
    };
    juuls.ecom                = {
        init: function () {
            juuls.ecom.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-juuls-set-quantity' ).on( 'click', juuls.ecom.setQuantity );
            jQuery( '.js-e-productlist' ).on( 'change', '.js-juuls-set-viewmode', function ( event ) {
                juuls.ecom.productlist.setViewMode( event.target.value );
            } ).on( 'builded.e4.productlist inserted.e4.productlist', function () {
                juuls.ecom.productlist.setViewMode();
            } ).on( 'mouseleave', '.view-mode', function ( event ) {
                jQuery( event.target ).find( '.js-e-product-favorites.show .dropdown-toggle' ).dropdown( 'toggle' );
            } );
        },
        setQuantity: function ( event ) {
            var intSetQuantity = parseInt( event.target.dataset.quantity ),
                jQuantity      = jQuery( event.target ).closest( '.js-e-product' ).find( '.js-juuls-cart-quantity' );
            jQuantity.val( intSetQuantity );
            jQuantity.closest('form').triggerHandler('submit');
        },
        productlist: {
            getCookie: function ( strCookieName ) {
                var name    = strCookieName + '=',
                    cookies = document.cookie.split( ';' );
                for ( var i = 0; i < cookies.length; i++ ) {
                    var cookie = cookies[ i ].trim();
                    if ( ( cookie.indexOf( name ) ) === 0 ) {
                        return cookie.substr( name.length );
                    }
                }
                return null;
            },
            getViewMode: function () {
                var strViewmode = 'grid';
                return strViewmode;
            },
            setViewMode: function ( strViewmode ) {
                document.cookie = 'juuls.viewmode=grid';
                /*
                var itemClasses = jQuery( '.js-viewmode-classes' ).data();
                if ( strViewmode !== undefined ) {
                    document.cookie = 'juuls.viewmode=grid';
                }
                else {
                    strViewmode = juuls.ecom.productlist.getViewMode();
                }
                if ( strViewmode === 'list' ) {
                    jQuery( '.view-mode' ).attr( 'class', itemClasses.viewClassesList );
                    jQuery( '.js-e-productlist' ).addClass( 'juuls-viewmode-list' );
                }
                else {
                    jQuery( '.view-mode' ).attr( 'class', itemClasses.viewClassesGrid );
                    jQuery( '.js-e-productlist' ).removeClass( 'juuls-viewmode-list' );
                }
                jQuery( '.js-juuls-set-viewmode-item[data-mode!="' + strViewmode + '"]' ).removeClass( 'active' );
                jQuery( '.js-juuls-set-viewmode-item[data-mode="' + strViewmode + '"]' ).addClass( 'active' );
                
                 */
            }
        }
    }
}() );
